import axios from 'axios'

const api = (function() {
  const _api = axios.create({
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 10000,
  })

  // SAS blob URLs must not include the Authorization header
  _api.interceptors.request.use(
    function(config) {
      if (config?.headers?.common) {
        delete config.headers.common.Authorization
      }
      if (config?.headers) {
        delete config.headers.Authorization
        delete config.headers.authorization
      }
      return config
    },
    null,
    { synchronous: true },
  )

  return {
    getBlobData: async url => {
      if (!url) return
      return _api.get(url, {
        timeout: 0,
      })
    },
  }
})()

export default api
